import "../css/index.css";
// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';

const swiper = new Swiper('.js-swiper-book-reviews', {
  slidesPerView: 1.1,
  spaceBetween: 20,
  modules: [Navigation],
  navigation: {
    nextEl: '.navigation-right',
    prevEl: '.navigation-left',
  },

  breakpoints: {
    900: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 2.5
    },
    600: {
      slidesPerView: 2
    },
    450: {
      slidesPerView: 1.5
    }
  }
});

function handleFaq() {
  const faq = document.querySelector('.js-faq');

  if (!faq) return;

  const faqItems = faq.querySelectorAll('.faq__item');

  faqItems.forEach(item => {
    item.addEventListener('click', () => {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      } else {
        faqItems.forEach(item => {
          item.classList.remove('active');
        });
        item.classList.add('active');
      }
    });
  });
}

handleFaq();

function handleMobileNav() {
  const target = document.querySelector('.js-header-menu-target');
  const mobileMenu = document.querySelector('.js-mobile-menu');

  if (!target || !mobileMenu) { return; }

  target.addEventListener('click', () => {
    target.classList.toggle('active');
    mobileMenu.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
  })
}

handleMobileNav();